"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnSnapchatAdsButtonClick = exports.useOnGroupToggle = exports.useOnMarketingNavItemClick = exports.useOnConsumerNavItemClick = exports.useOnDownloadButtonClick = exports.useOnItemClick = exports.getConsumerApp = void 0;
const web_blizzard_reporting_1 = require("@snapchat/web-blizzard-reporting");
const web_consumer_nav_1 = require("@snapchat/web-consumer-nav");
const react_1 = require("react");
/**
 * Making sure consumer app is set
 */
function getConsumerApp(appType) {
    return !appType ? web_consumer_nav_1.ConsumerApp.Unset : appType;
}
exports.getConsumerApp = getConsumerApp;
/**
 *
 */
function useOnItemClick(pageType, isMobile, webClientId) {
    return (0, react_1.useCallback)((_event, label) => {
        (0, web_blizzard_reporting_1.reportWebAction)({
            pageType,
            actionName: web_blizzard_reporting_1.WebActionName.NavigationClick,
            destination: label,
            webClientId,
            actionSource: isMobile ? web_blizzard_reporting_1.WebActionSource.MobileNav : web_blizzard_reporting_1.WebActionSource.DesktopNav,
        });
    }, [isMobile, pageType, webClientId]);
}
exports.useOnItemClick = useOnItemClick;
/**
 *
 */
function useOnDownloadButtonClick(pageType, webClientId) {
    return (0, react_1.useCallback)((_event) => {
        (0, web_blizzard_reporting_1.reportWebAction)({
            pageType,
            actionName: web_blizzard_reporting_1.WebActionName.NavigationClick,
            destination: web_consumer_nav_1.DesktopNavItemType.DOWNLOAD,
            webClientId,
        });
    }, [pageType, webClientId]);
}
exports.useOnDownloadButtonClick = useOnDownloadButtonClick;
/**
 *
 */
function useOnConsumerNavItemClick(pageType, isMobile, webClientId) {
    return (0, react_1.useCallback)((_event, item) => {
        (0, web_blizzard_reporting_1.reportWebAction)({
            pageType,
            actionName: web_blizzard_reporting_1.WebActionName.NavigationClick,
            destination: item.label,
            webClientId,
            actionSource: isMobile ? web_blizzard_reporting_1.WebActionSource.MobileNavIcon : web_blizzard_reporting_1.WebActionSource.DesktopNavIcon,
        });
        // web chat is only supported in desktop broswer
        if (!isMobile && item.label === web_consumer_nav_1.DesktopNavItemType.CHAT) {
            void (0, web_blizzard_reporting_1.reportWebAction)({
                pageType,
                actionName: web_blizzard_reporting_1.WebActionName.OpenWebChatHeader,
                destination: item.label,
                webClientId,
            });
        }
    }, [pageType, webClientId, isMobile]);
}
exports.useOnConsumerNavItemClick = useOnConsumerNavItemClick;
/**
 *
 */
function useOnMarketingNavItemClick(pageType, webClientId) {
    return (0, react_1.useCallback)((_event, item) => {
        (0, web_blizzard_reporting_1.reportWebAction)({
            pageType,
            actionName: web_blizzard_reporting_1.WebActionName.NavigationClick,
            destination: item.label,
            webClientId,
        });
    }, [pageType, webClientId]);
}
exports.useOnMarketingNavItemClick = useOnMarketingNavItemClick;
/**
 *
 */
function useOnGroupToggle(pageType, webClientId) {
    return (0, react_1.useCallback)((_event, _item) => {
        (0, web_blizzard_reporting_1.reportWebAction)({
            pageType,
            actionName: web_blizzard_reporting_1.WebActionName.NavigationClick,
            // We don't want to pass item.label (e.g. snapchat.com or business) for onGroupToggle.
            // This is because for now we don't care about which sub menu category was
            // clicked by a user. We only care about the total amount of clicks for sub menu.
            destination: web_consumer_nav_1.DesktopNavItemType.SUB_MENU,
            webClientId,
        });
    }, [pageType, webClientId]);
}
exports.useOnGroupToggle = useOnGroupToggle;
/**
 *
 */
function useOnSnapchatAdsButtonClick(pageType, webClientId) {
    return (0, react_1.useCallback)((_event) => {
        (0, web_blizzard_reporting_1.reportWebAction)({
            pageType,
            webClientId,
            actionName: web_blizzard_reporting_1.WebActionName.AdvertisersCTA,
        });
    }, [pageType, webClientId]);
}
exports.useOnSnapchatAdsButtonClick = useOnSnapchatAdsButtonClick;
//# sourceMappingURL=util.js.map